require("core-js/features/url");
require("./utils/array.native");
require("./utils/object.native");

(async function() {
  const config = require("./config").default;
  await config();

  require("./config-app");
  require("./config-features");
  require("./webview");
  require("./bootstrap");
  require("./app-view");
})();
